/* eslint-disable react/jsx-no-undef */
import React, { useContext, useEffect } from 'react';
import { includes, isEmpty, toLower } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SearchEventContext from '../context/SearchEventContext';
import { convertMonthToAr, isCurrDate, startEndDateToString } from '../helpers/date-convert';
import { Container } from './styles/Container.styled';
import DatePickerContext from '../context/DatePickerContext';
import NotFoundSearchMsg from './NotFoundSearchMsg';
import {
  ServicesResult,
  AllServices,
  ServiceColumn,
  ServicesCard,
  ServicesText,
  ServicesImage,
  EventHead,
  EventInfo,
  VenueText,
} from './styles/ThreeColumnServicesBlock.styled';
import EIndustry from '../assets/svg/eindustry.svg';
import EPurpose from '../assets/svg/epurpose.svg';
import Location from '../assets/svg/elocation.svg';
import EType from '../assets/svg/etype.svg';
import { getTranslationByKey } from '../helpers/translation-helper';
import { DWTCContext } from '../utils/context';
import venuesHandler from '../helpers/venues-handler';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';

export default function EventsListing({ events, dir }) {
  const { translations } = useContext(DWTCContext);
  const { listing, eventsList, setEventsList, eventFilterArray, setTotalFilteredEvents } =
    useContext(SearchEventContext);
  const { month, year } = useContext(DatePickerContext);
  const isArabic = dir === 'rtl';
  const [loadMore, setLoadMore] = React.useState(false);

  const [hasMore, setHasMore] = React.useState(false);

  const handleLoadMore = () => {
    setLoadMore(true);
    setHasMore(false);
  };

  useEffect(() => {
    let filteredEvents = [];
    if (eventFilterArray[0]) filteredEvents = events;
    else {
      filteredEvents = events.filter((event) =>
        isCurrDate(month, year, event.startDate, event.endDate),
      );
    }

    filteredEvents = filteredEvents
      .filter((event) =>
        eventFilterArray[0] ? includes(toLower(event.title), toLower(eventFilterArray[0])) : true,
      )
      .filter((event) =>
        eventFilterArray[1]
          ? includes(toLower(event.eventType), toLower(eventFilterArray[1]))
          : true,
      )
      .filter((event) =>
        eventFilterArray[2]
          ? includes(toLower(event.eventSectors), toLower(eventFilterArray[2]))
          : true,
      );
    setTotalFilteredEvents(filteredEvents.length);
    filteredEvents.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    if (filteredEvents.length > 12 && !loadMore) {
      setHasMore(true);
      setEventsList(filteredEvents.slice(0, 12));
    } else {
      setEventsList(filteredEvents);
      setHasMore(false);
    }
  }, [eventFilterArray, month, year, loadMore]);

  const handleEventVenues = (venues) => venuesHandler(venues, translations);

  // const arabicRegEx = /[\u0600-\u06FF]/;

  return isEmpty(eventsList) ? (
    <NotFoundSearchMsg dir={dir} />
  ) : (
    <ServicesResult className="padding-0">
      <Container>
        <AllServices
          className={(listing === 'grid' && '') || (listing === 'listpress' && 'listpress')}
          dir={dir}
        >
          {eventsList.map((event, index) => (
            <ServiceColumn className="event_slide" key={`eventsList-${index}`}>
              <ServicesCard href={event.url} className="service_wrappercard">
                <ServicesText className="event_text" dir={dir}>
                  <EventHead className="event-head">
                    <time className="e-date" dir={dir}>
                      {isArabic
                        ? convertMonthToAr(startEndDateToString(event.startDate, event.endDate))
                        : startEndDateToString(event.startDate, event.endDate)}
                    </time>
                    <h3 dir={dir} className="e-title e-grid">
                      {event.title}
                    </h3>
                    <h3 dir={dir} className="e-title e-list">
                      {event.title}
                    </h3>
                  </EventHead>
                  <EventInfo className="event-info" dir={dir}>
                    <span className="e-grid" dir={dir}>
                      {getTranslationByKey(translations, event.eventSectors[0])}
                    </span>
                    <span className="e-industry e-list">
                      <EIndustry className="svgicon" />
                      {getTranslationByKey(translations, event.eventSectors[0])}
                    </span>
                    <span className="e-purpose">
                      <EPurpose className="svgicon" />
                      {getTranslationByKey(translations, event.eventAudiences)}
                    </span>
                    <span className="e-venue">
                      <Location className="svgicon" />
                      {handleEventVenues(event.eventVenues).map((value) => (
                        <VenueText>{value}</VenueText>
                      ))}
                    </span>
                    <span className="e-type">
                      <EType className="svgicon" />
                      {getTranslationByKey(translations, event.eventType[0])}
                    </span>
                  </EventInfo>
                </ServicesText>
                <ServicesImage>
                  {isEmpty(event.featuredImage) || (
                    <LazyLoadImage
                      src={event.featuredImage.url}
                      effect="blur"
                      placeholderSrc={
                        event.featuredImage.url
                          ? `${event.featuredImage.url}?width=50&quality=50`
                          : null
                      }
                      width={367}
                      height={376}
                    />
                  )}
                </ServicesImage>
              </ServicesCard>
            </ServiceColumn>
          ))}
          {hasMore && (
            <LoadMoreGenericBtn
              color="blue"
              position="center"
              label={getTranslationByKey(translations, 'Load More')}
              onClick={handleLoadMore}
              dir={dir}
            />
          )}
        </AllServices>
      </Container>
    </ServicesResult>
  );
}
